import { getRequest } from 'src/utils/http';
import { rolesController } from './consts';

export const getRoles = async (params) => getRequest(`${rolesController}`, params);
